<template>
  <div id="app">
    <!-- <button @click="init">初始化</button> -->
    <tab-bar class="menu"></tab-bar>
    <div class="content"
      :style="{ height: contentHeight, background: '-webkit-linear-gradient(left, ' + $store.state.baseColor + ',' + $store.state.baseSecondColor + ')' }">
      <rb-center-top @setWxBindCallback="setWxBindCallback"></rb-center-top>
      <br />
      <router-view></router-view>
    </div>
    <Loading v-if="$store.state.showLoading" />
    <Alert v-if="$store.state.showAlert" />
    <Toast v-if="$store.state.showToast" />
    <AlertWxBind v-if="$store.state.showWxBindPage" />
  </div>
</template>

<script>

import TabBar from "views/tabbar/TabBar.vue";
import RbCenterTop from "views/RebateView/RbCenterTop.vue";
import CashOut from "views/RebateView/CashOut/CashOut.vue";
import ChangePassword from "views/MineView/ChangePassword.vue";
import ExchangeLog from "views/RebateView/ExchangeLog/ExchangeLog.vue";
import AlertWxBind from 'views/alert/AlertWxBind.vue';
import Loading from "views/loading/Loading.vue";
import Alert from "views/alert/Alert.vue";
import Toast from "views/alert/Toast.vue";
import utils from './utils';
import { request } from './network/request';
import getRequestParams from "./signParams";
import Vue from 'vue';
import urls from 'network/urls';
import urlsv2 from 'network/urlsv2';

export default {
  name: 'App',
  data() {
    return {
      contentHeight: '100vh'
    }
  },
  components: {
    TabBar,
    RbCenterTop,
    CashOut,
    ChangePassword,
    ExchangeLog,
    Loading,
    Alert, Toast, AlertWxBind
  },
  created: function () {
    // 获取url中的param=后面的参数值，在这里携带的是{"key":"value"}的json形式
    let params = utils.getUrlKey("param")
    // 将获取到的参数更新到store中，方面后续获取公共参数
    this.$store.commit('updateCommonParams', params)

    // 判斷是哪個版本的紅包
    let rebatev2 = this.$store.state.commonParameters['rebatev2']
    if (rebatev2 === 'true') {// 使用红包版本v2的api
      Vue.prototype.urls = urlsv2
    } else {
      Vue.prototype.urls = urls
      // 如果是rebateUI1的红包，需要修改颜色值
      let rebateUI1 = this.$store.state.commonParameters['rebateUI1'];
      if ('true' == rebateUI1) {
        this.$store.commit("updateBaseColorAndSecondColor", { 'baseColor': '#fb3455', 'baseSecondColor': '#fb3455' });
        // 还需要将红包中心的所有资源换成新的，这里设置一个标志，在资源路径引用的时候判断下
        this.$store.commit('updateRebateUI1Open', true);
      }

    }
    // 从store获取公共参数,这些参数是在一开始就获取到的
    let storeCommomParams = this.$store.getters.getCommomParams;
    // 使用公共参数转换成用于请求api需要的参数值形式
    let signParams = getRequestParams({}, storeCommomParams);
    // 先去获取rid，phone，更新到基本参数中去，再去请求红包初始化，红包用户信息
    request({
      url: this.urls.REBATE_INFO,
      params: {
        data: signParams // 在url后面加上&data=[signParams具体内容]
      },
    }).then(res => {
      // 更新公共参数中的rid和phone，不直接从原始公共参数中传递。是为了避免直接暴露rid
      this.$store.dispatch("networkUpdateRid", { "rid": res["rid"], "phone": res["phone"] })
      signParams = getRequestParams({}, storeCommomParams);
      let rebateInitReq = request({
        url: this.urls.REBATE_INIT,
        params: {
          data: signParams
        },
      })
      let rebateUser = request({
        url: this.urls.REBATE_USER,
        params: {
          data: signParams
        },
      })
      // 将红包初始化，和红包用户接口两个请求合并，当两个请求都成功才处理then里面的内容
      Promise.all([rebateInitReq, rebateUser]).then(values => {
        // console.log(values);
        // 网络请求异步的数据，需要用 dispatch
        let payload = { "initData": values[0], "userInfoData": values[1] }
        this.$store.dispatch('networkHandleRebateAndUserInit', payload)

        // 加载瓜分红包和等级红包  红包类型ID，瓜分红包ID：(新版本红包的是2， 旧版本的是9)   等级红包ID：1   
        let divideRebateType = "9";
        if (rebatev2 === 'true') {
          divideRebateType = "2";
        }
        // 瓜分红包 
        let divideReqParams = getRequestParams({ "typeid": divideRebateType }, storeCommomParams);
        let divideReq = request({
          url: this.urls.REBATE_SHOW,
          params: {
            data: divideReqParams
          },
        })
        // 等级红包 
        let levelReqParams = getRequestParams({ "typeid": "1" }, storeCommomParams);
        let levelReq = request({
          url: this.urls.REBATE_SHOW,
          params: {
            data: levelReqParams
          },
        })
        // 同时获取瓜分红包和等级红包的数据
        Promise.all([divideReq, levelReq]).then(res => {
          // console.log(res);
          // 网络请求异步的数据，需要用 dispatch
          let payload = { "divideListData": res[0], "levelRebateListData": res[1] }
          this.$store.dispatch('networkHandleRebateList', payload)
        })
      })
    })
    // 通知安卓端，H5已经准备好，可以发送需要数据过来了，目前只要客服未读信息
    // this.sendToClient('sdkFinish?')
    // 是否是横屏,修改高度，方便滑動
    if (storeCommomParams['landGame'] === 'true') {
      this.contentHeight = "165vh"
    }
  },
  mounted: function () {

  },
  methods: {
    setWxBindCallback() {
      // console.log("点击绑定微信");
      let storeCommomParams = this.$store.getters.getCommomParams;
      // 这里显示绑定提取方式  ct=rebate&ac=wxAuth  获取微信绑定二维码展示
      let wxBindReqParams = getRequestParams({}, storeCommomParams);
      request({
        url: this.urls.REBATE_WXAUTH,
        params: {
          data: wxBindReqParams
        },
      }).then(res => {
        // console.log(res);
        // console.log(JSON.parse(res.param)['url']);
        if ("qrcode" == res.type) {
          let qrcodeUrl = JSON.parse(res.param)['url'];
          this.$store.dispatch('networkWxBindPageShow', { "showOrHide": true, "qrcodeUrl": qrcodeUrl })
        } else {
          this.$store.commit("switchToast", { "showOrHide": true, "toastMessage": "暂无绑定方式" })
          this.$store.dispatch('networkWxBindPageShow', { "showOrHide": false, "qrcodeUrl": "" })
        }
      })

    },
  }
}
</script>

<style>
body {
  padding-top: 0%;
  margin: 0%;
}

.menu {
  position: fixed;
}

.content {
  /* background: -webkit-linear-gradient(left, #D32723,#EB473E); */
  /* width: 80%; 用百分比的话，会在安卓端WebView加载后，整个界面左右上下滑动出一点空白，不好看。使用vw可以避免这种情况 */
  width: 80vw;
  height: 100vh;
  overflow-y: auto;
  float: right;
  display: flex;
  flex-flow: column;
}

input {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue